import { render, staticRenderFns } from "./CompanyMobile.vue?vue&type=template&id=70e9934e&scoped=true"
import script from "./CompanyMobile.vue?vue&type=script&lang=js"
export * from "./CompanyMobile.vue?vue&type=script&lang=js"
import style0 from "./CompanyMobile.vue?vue&type=style&index=0&id=70e9934e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e9934e",
  null
  
)

export default component.exports